// extracted by mini-css-extract-plugin
module.exports = {"link":"AvatarComponent_link__AcFf5","avatar_wrapper":"AvatarComponent_avatar_wrapper__2XvAz","avatar_text":"AvatarComponent_avatar_text__1ryrQ"};